import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useFetch from "../../Hooks/useFetch";
import WebinarModal from "./WebinarModal";

const WebinarButton = ({ onClick }) => {
  const { t } = useTranslation();
  const { fetchData } = useFetch();
  const [hasWebinars, setHasWebinars] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    checkWebinars();
  }, []);

  const checkWebinars = async () => {
    try {
      const result = await fetchData("webinars/check");
      if (result?.data?.hasWebinars) {
        setHasWebinars(true);
      }
    } catch (error) {
      console.error("Error checking webinars:", error);
    }
  };

  const handleClick = () => {
    setIsModalOpen(true);
    if (onClick) onClick();
  };

  // Don't render if no webinars
  if (!hasWebinars) return null;

  return (
    <>
      <button
        onClick={handleClick}
        className="bg-primary hover:bg-primary/90 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 flex items-center gap-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
          />
        </svg>
        {t("webinar.button")}
      </button>

      <WebinarModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default WebinarButton;
